/* Wish Karo: product header helpers (loaded on product pages from layout/theme.liquid)
   1. Small "copy SKU" button next to the SKU line (for the team)
   2. Sale badge shows the real saving ("56% off") instead of the word "Sale"
   Both re-run when the theme swaps price/SKU markup after a variant change. */
(function () {
  var COPY_ICON =
    '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
    '<rect x="5.2" y="5.2" width="8.3" height="8.3" rx="1.6" fill="none" stroke="currentColor" stroke-width="1.4"/>' +
    '<path d="M2.8 10.6V3.9c0-.6.5-1.1 1.1-1.1h6.7" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>' +
    '</svg>';

  function skuOf(p) {
    var c = p.cloneNode(true);
    c.querySelectorAll('.visually-hidden, .wk-sku-copy').forEach(function (n) { n.remove(); });
    return c.textContent.trim();
  }

  function addSkuButtons() {
    document.querySelectorAll('.product__info-container .product__sku').forEach(function (p) {
      if (p.querySelector('.wk-sku-copy') || !skuOf(p)) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'wk-sku-copy';
      b.title = 'Copy SKU';
      b.setAttribute('aria-label', 'Copy SKU');
      b.innerHTML = COPY_ICON + '<span class="wk-sku-copy__done">Copied</span>';
      p.appendChild(b);
    });
  }

  function copyText(text, done) {
    var fallback = function () {
      var t = document.createElement('textarea');
      t.value = text;
      t.setAttribute('readonly', '');
      t.style.position = 'fixed';
      t.style.opacity = '0';
      document.body.appendChild(t);
      t.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(t);
      done();
    };
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(done, fallback);
    } else {
      fallback();
    }
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.wk-sku-copy');
    if (!b) return;
    var p = b.closest('.product__sku');
    copyText(skuOf(p), function () {
      b.classList.add('is-copied');
      b.setAttribute('aria-label', 'SKU copied');
      clearTimeout(b._wkT);
      b._wkT = setTimeout(function () {
        b.classList.remove('is-copied');
        b.setAttribute('aria-label', 'Copy SKU');
      }, 1500);
    });
  });

  function amount(el) {
    var m = el && el.textContent.match(/\d[\d,]*(\.\d+)?/);
    return m ? parseFloat(m[0].replace(/,/g, '')) : 0;
  }

  function updateSaleBadges() {
    document.querySelectorAll('.product__info-container .price--on-sale').forEach(function (pr) {
      var sale = pr.querySelector('.price__sale .price-item--sale');
      var was = pr.querySelector('.price__sale s.price-item--regular');
      var badge = pr.querySelector('.price__badge-sale');
      if (!sale || !was || !badge) return;
      var now = amount(sale), before = amount(was);
      if (!(before > now && now > 0)) return;
      var pct = Math.round(((before - now) / before) * 100);
      if (pct < 1) return;
      var label = pct + '% off';
      if (badge.textContent.trim() !== label) badge.textContent = label;
    });
  }

  function run() {
    addSkuButtons();
    updateSaleBadges();
  }

  function start() {
    run();
    var info = document.querySelector('.product__info-container');
    if (!info || !window.MutationObserver) return;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () { queued = false; run(); }, 0);
    }).observe(info, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
